import { IconBank } from '@iwoca/icons';
import { Text } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';

import { useGetLinkedAccounts } from '../../../../modals/BankSelectionModal/useGetLinkedAccounts';
import {
    RequirementItem,
    TFundingRequirementStatus
} from '../RequirementsList/RequirementItem/RequirementItem';

type TUploadBankEvidenceStepProps = {
    status: TFundingRequirementStatus;
};

export const UploadBankEvidenceStep = ({
    status
}: TUploadBankEvidenceStepProps) => {
    const linkedAccounts = useGetLinkedAccounts();
    const linkedAccount = linkedAccounts[0];
    const hasLinkedAccount =
        !!linkedAccount?.bankName && !!linkedAccount?.accountNumberMasked;

    const title = (
        <FormattedMessage
            id="_.funding_requirements.upload_bank_evidence_step.title"
            defaultMessage="Verify your account"
        />
    );

    return (
        <RequirementItem
            title={title}
            estimatedTime={
                <FormattedMessage
                    id="_.funding_requirements.estimated_time"
                    defaultMessage="~ {minutes} mins"
                    values={{ minutes: 2 }}
                />
            }
            href="/funding-requirements/link-open-banking"
            status={status}
            completedView={
                <div>
                    <Text className="font-med text-primary-10">{title}</Text>
                    <div className="my-s flex items-center gap-m text-s text-structure-40">
                        {hasLinkedAccount ? (
                            <>
                                <IconBank className="text-m" />
                                <span>
                                    <FormattedMessage
                                        id="_.funding_requirements.upload_bank_evidence_step.linked_account"
                                        defaultMessage="{bankName} account ending in {last4} is linked"
                                        values={{
                                            bankName: linkedAccount.bankName,
                                            last4: linkedAccount.accountNumberMasked
                                        }}
                                    />
                                </span>
                            </>
                        ) : (
                            <span>
                                <FormattedMessage
                                    id="_.funding_requirements.upload_bank_evidence_step.under_review"
                                    defaultMessage="Your account is under review"
                                />
                            </span>
                        )}
                    </div>
                </div>
            }
        />
    );
};
